// import axios from 'axios'
import axiosInstance from '../../../../helpers/axiosConfig';
import config from '../../../../config';


export const loginAuth = async (data) => {
  const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL
  //console.log('Request URL:', `${baseUrl}Authentication/Login`);

  //console.log('DATOS: ',data)
  try {
    const response = await axiosInstance.post(
      `${baseUrl}Authentication/Login`,
      data,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    )

    //console.log('response del login: ', response)

    if (response.status === 200 && response.data.accessToken) {


      //console.log('response.data.accessToken', response.data.accessToken)
      const calculateExpiresAt = (expiresIn) => Math.floor(Date.now() / 1000) + expiresIn;
      const expiresAt = calculateExpiresAt(response.data.expiresIn);

      localStorage.setItem('access-token', response.data.accessToken)
      localStorage.setItem('refresh-token', response.data.refreshToken)
      localStorage.setItem('expire-in', expiresAt)
      localStorage.setItem('token-type', response.data.tokenType)


    }


    return response
  } catch (error) {
    // console.error('Service Error:', error)
    // console.error('error response:', error.response)

    throw error
  }
}

export const forgotPassword = async (data) => {

  const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

  try {
    const response = await axiosInstance.post(
      `${baseUrl}Authentication/forgotPassword`,
      data,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    )

     //console.log('forgotPassword response: ', response)

     return response

  } catch (error) {
    // console.error('Service Error:', error)
    // console.error('error response:', error.response)

    throw error
  }
}

